import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import GmpThermalChecklist from "@/pages/GmpThermalChecklist";

export const Route = createFileRoute("/es/checklist-cualificacion-sistemas-termicos-gmp")({
  head: () => buildRouteHead("/es/checklist-cualificacion-sistemas-termicos-gmp"),
  component: GmpThermalChecklist,
});

